import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'

type RefusedContentProps = {
  record: any
  recordDetails?: any
}

const RefusedContent = ({ record, recordDetails }: RefusedContentProps) => {
  const { t } = useTranslation(NAMESPACE.EMAR_V2)

  const stockChanged = recordDetails?.stockChanged || false
  const stockRemoved = recordDetails?.stockRemoved || ''
  const comment = recordDetails?.comment || ''

  return (
    <>
      <QuestionRow>
        <Label level={2}>
          {t('HAS_STOCK_AMOUNT_CHANGED') || 'Has the stock amount changed?'}
        </Label>
        <Value>{stockChanged ? t('YES') || 'Yes' : t('NO') || 'No'}</Value>
      </QuestionRow>
      {stockChanged && stockRemoved && (
        <InfoRow>
          <Label level={2}>
            {t('YES_REMOVED_FROM_STOCK') || 'Yes, removed from stock'}
          </Label>
          <Value>{stockRemoved}</Value>
        </InfoRow>
      )}
      {comment && (
        <InfoRow>
          <Label level={2}>{t('COMMENT')}</Label>
          <Value>{comment}</Value>
        </InfoRow>
      )}
    </>
  )
}

const QuestionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const Label = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color5};
  font-weight: 500;
`

const Value = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
  font-weight: 400;
`
const InfoRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export default RefusedContent
